import React from 'react';
import moment from 'moment';
import FilterInputField from '../../components/TableFilter/ColumnsFilters/FilterInputField';
import { Color } from '../ThemeProvider/ThemeStyle';
import Checkbox from '@material-ui/core/Checkbox';

const styles = {
  textAlign: 'center',
  alignSelf: 'center'
};

const styles_head = {
  position: 'relative'
};

export const ReportColumns = ({
  t,
  days,
  open,
  cause,
  lang,
  isShowSum,
  isEditHead,
  isEdit,
  checkedList,
  setCheckedList,
  reportList,
  isMarkEnabled
}) => {
  let newDays = [];
  days &&
    days.forEach(item => {
      newDays.push({
        Header: (
          <div
            onClick={() => {
              if (open && isEditHead && isEdit) {
                open({
                  isHead: true,
                  logDate: item,
                  isVisited: false,
                  cause: 'TECHNICAL_ERROR'
                });
              }
            }}
            className={isEditHead ? 'rt-th-my rt-th-my_hover' : 'rt-th-my'}
          >
            {String(moment(item).format('DD'))}
          </div>
        ),
        style: styles_head,
        accessor: item,
        Cell: ({ original }) => {
          let currentVisited = null;
          let text = null;
          if (original?.visitsInfo) {
            original.visitsInfo.forEach(visitInfo => {
              if (visitInfo.logDate === item) {
                currentVisited = visitInfo;
                currentVisited['userID'] = original.childId
                  ? original.childId
                  : original.staffId;
              }
            });
          }
          cause.forEach(item => {
            if (item.code === currentVisited?.['absenceReason']) {
              if (lang === 'ru') {
                text = item?.fisrt_letter_ru;
              } else {
                text = item?.first_letter_kk;
              }
            }
          });
          return (
            <>
              {currentVisited?.isVisited === false && (
                <div
                  style={{
                    backgroundColor:
                      (currentVisited.absenceReason && Color.injury) || Color.secondary,
                    textAlign: 'center',
                    transform: 'scale(2)',
                    marginTop: 1,
                    display: 'list-item',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    if (open) {
                      open(currentVisited);
                    }
                  }}
                >
                  {text ? (
                    <span
                      style={{
                        transform: 'scale(0.45)',
                        display: 'block',
                        color: '#000',
                        minWidth: '2px'
                      }}
                    >
                      {' '}
                      {text}{' '}
                    </span>
                  ) : (
                    <span
                      style={{
                        transform: 'scale(0.45)',
                        display: 'block',
                        color: Color.secondary,
                        minWidth: '2px'
                      }}
                    >
                      {' '}
                      -{' '}
                    </span>
                  )}
                </div>
              )}
              {currentVisited?.isVisited === true && (
                <div
                  style={{
                    backgroundColor: Color.bgColorSuccess,
                    textAlign: 'center',
                    transform: 'scale(2)',
                    marginTop: 1,
                    display: 'list-item',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    if (open) {
                      open(currentVisited);
                    }
                  }}
                >
                  <span style={{ transform: 'scale(0.55)', display: 'block' }}> + </span>
                </div>
              )}
            </>
          );
        },
        Filter: <span></span>
      });
    });

  let daysTable = [
    ...(isMarkEnabled
      ? [
          {
            Header: (
              <Checkbox
                checked={
                  !!reportList.length &&
                  checkedList.length > 0 &&
                  checkedList.length ===
                    reportList.filter(child => {
                      const today = moment().format('YYYY-MM-DD');
                      return !child.visitsInfo?.some(
                        v =>
                          moment(v.logDate).format('YYYY-MM-DD') === today &&
                          v.isVisited === true
                      );
                    }).length
                }
                indeterminate={
                  !!checkedList.length &&
                  checkedList.length <
                    reportList.filter(child => {
                      const today = moment().format('YYYY-MM-DD');
                      return !child.visitsInfo?.some(
                        v =>
                          moment(v.logDate).format('YYYY-MM-DD') === today &&
                          v.isVisited === true
                      );
                    }).length
                }
                onClick={e => e.stopPropagation()}
                onChange={e => {
                  e.stopPropagation();

                  const today = moment().format('YYYY-MM-DD');
                  const selectableIds = reportList
                    .filter(
                      child =>
                        !child.visitsInfo?.some(
                          v =>
                            moment(v.logDate).format('YYYY-MM-DD') === today &&
                            v.isVisited === true
                        )
                    )
                    .map(child => String(child.childId ?? child.staffId));

                  if (e.target.checked) {
                    setCheckedList(selectableIds);
                  } else {
                    setCheckedList([]);
                  }
                }}
              />
            ),
            accessor: 'checkbox',
            maxWidth: 150,
            width: 150,
            sortable: false,
            filterable: false,
            Cell: ({ original }) => {
              if (original.totalFinish) return null;

              const id = String(original.childId ?? original.staffId);
              const isChecked = checkedList.includes(id);

              const today = moment().format('YYYY-MM-DD');
              const isVisitedToday = original?.visitsInfo?.some(
                visit =>
                  moment(visit.logDate).format('YYYY-MM-DD') === today &&
                  visit.isVisited === true
              );

              return (
                <Checkbox
                  checked={isChecked}
                  disabled={isVisitedToday}
                  onClick={e => e.stopPropagation()}
                  onChange={e => {
                    e.stopPropagation();
                    if (e.target.checked) {
                      setCheckedList([...checkedList, id]);
                    } else {
                      setCheckedList(checkedList.filter(item => item !== id));
                    }
                  }}
                />
              );
            }
          }
        ]
      : []),
    {
      Header: '№',
      accessor: 'rowNumber',
      maxWidth: 100,
      width: 100,
      filterable: false,
      Cell: row => row.original.iin && row.index + 1
    },
    {
      Header: 'ID',
      accessor: 'childId',
      Filter: <FilterInputField name="childId" type="number" />,
      maxWidth: 150,
      width: 150,
      Cell: ({ original }) => {
        return (
          <div>
            {original.childId && original.childId}
            {original.staffId && original.staffId}
          </div>
        );
      }
    },
    {
      Header: t('pageReport_fullName'),
      accessor: 'fullName',
      Filter: <FilterInputField name="fullName" />,
      Cell: ({ original }) => {
        return (
          <div style={{ fontWeight: original.totalFinish ? 600 : null }}>
            {original.surname} {original.name} {original?.middlename}
          </div>
        );
      },
      maxWidth: 470,
      width: 470
    },
    ...newDays,
    {
      Header: t('pageReport_visitedDays'),
      accessor: 'visitedDays',
      Filter: <span></span>,
      maxWidth: 250,
      width: 250,
      style: styles,
      Cell: ({ original }) => {
        return (
          <div style={{ fontWeight: original.totalFinish ? 600 : null }}>
            {original.visitedDays}
          </div>
        );
      }
    },
    {
      Header: (
        <div>
          <p className="reportBorderBottom">{t('pageReport_missedDays')}</p>
          <div style={{ display: 'flex' }}>
            <p
              className="reportBorderRight reportCauseTable"
              style={{ width: '15%', maxWidth: '15%' }}
            >
              {t('pageReport_reference')}
            </p>
            <p
              className="reportBorderRight reportCauseTable"
              style={{ width: '30%', maxWidth: '30%' }}
            >
              {t('pageReport_applicationLeave')}
            </p>
            <p
              className="reportBorderRight reportCauseTable"
              style={{ width: '30%', maxWidth: '30%' }}
            >
              {t('pageReport_statementParents')}
            </p>
            <p className="reportCauseTable" style={{ width: '23%', maxWidth: '26%' }}>
              {t('pageReport_withReason')}
            </p>
            <p className="reportCauseTable" style={{ width: '23%', maxWidth: '26%' }}>
              {t('pageReport_technicalError')}
            </p>
          </div>
        </div>
      ),
      accessor: 'unvisitedDaysWithoutReason',
      Filter: <span></span>,
      maxWidth: 2100,
      width: 2100,
      Cell: ({ original }) => {
        return (
          <div style={{ display: 'flex' }}>
            <p
              className="reportBorderRight reportCauseTable"
              style={{
                width: '15%',
                maxWidth: '15%',
                fontWeight: original.totalFinish ? 600 : null
              }}
            >
              {original.unvisitedDaysWithReasonReference}
            </p>
            <p
              className="reportBorderRight reportCauseTable"
              style={{
                width: '30%',
                maxWidth: '30%',
                fontWeight: original.totalFinish ? 600 : null
              }}
            >
              {original.unvisitedDaysWithReasonLeaveApplication}
            </p>
            <p
              className="reportBorderRight reportCauseTable"
              style={{
                width: '30%',
                maxWidth: '30%',
                fontWeight: original.totalFinish ? 600 : null
              }}
            >
              {original.unvisitedDaysWithReasonParentStatement}
            </p>
            <p
              className="reportBorderRight reportCauseTable"
              style={{
                width: '23%',
                maxWidth: '26%',
                fontWeight: original.totalFinish ? 600 : null
              }}
            >
              {original.unvisitedDaysWithoutReason}
            </p>
            <p
              className="reportCauseTable"
              style={{
                width: '23%',
                maxWidth: '26%',
                fontWeight: original.totalFinish ? 600 : null
              }}
            >
              {original.unvisitedDaysWithReasonTechnicalError}
            </p>
          </div>
        );
      },
      style: styles
    },
    {
      Header: t('pageReport_childrenDays'),
      accessor: 'childDays',
      Filter: <span></span>,
      maxWidth: 250,
      width: 250,
      style: styles,
      Cell: ({ original }) => {
        return (
          <div style={{ fontWeight: original.totalFinish ? 600 : null }}>
            {original.childDays}
          </div>
        );
      }
    }
  ];
  isShowSum &&
    daysTable.push({
      Header: t('pageReport_sum'),
      accessor: 'visitSumma',
      Filter: <span></span>,
      maxWidth: 350,
      width: 350,
      Cell: ({ original }) => {
        let price = original.visitSumma.toFixed(2),
          price_sep2 = price.replace(/(\D)/g, ','),
          price_sep3 = price_sep2.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
        return (
          <div style={{ fontWeight: original.totalFinish ? 600 : null }}>
            {price_sep3}
          </div>
        );
      },
      style: styles
    });
  return daysTable;
};
